export default __webpack_public_path__ + "static/sayless-symbol-187a4621ec3f31d49f4dfb23d92fe27a.png";